import '@portal/components/font/aeonikPro/aeonik.css'
import '@portal/components/font/ibmPlexMono/ibmPlexMono.css'
import '@portal/components/font/inconsolata/inconsolata.css'
import '@portal/components/font/inter/inter.css'
import '@portal/components/font/kairos/kairos.css'
import 'core-js'
import 'overlayscrollbars/overlayscrollbars.css'
import './index.css'

import App from 'App'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import duration from 'dayjs/plugin/duration'
import isYesterday from 'dayjs/plugin/isYesterday'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import React from 'react'
import { createRoot } from 'react-dom/client'
import TagManager from 'react-gtm-module'
import { initSentry } from 'utils/sentry'

initSentry()

dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(duration)
dayjs.extend(localizedFormat)
dayjs.extend(isYesterday)
dayjs.extend(utc)

const windowEnvironment = window._env_

if (
  windowEnvironment.GOOGLE_TAG_MANAGER_KEY &&
  windowEnvironment.GOOGLE_TAG_MANAGER_ENV_AUTH &&
  windowEnvironment.GOOGLE_TAG_MANAGER_PREVIEW_ENV_ID
) {
  TagManager.initialize({
    gtmId: windowEnvironment.GOOGLE_TAG_MANAGER_KEY,
    auth: windowEnvironment.GOOGLE_TAG_MANAGER_ENV_AUTH,
    preview: windowEnvironment.GOOGLE_TAG_MANAGER_PREVIEW_ENV_ID,
  })
}

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
